import { observer } from 'mobx-react';
import { useStore } from 'app/context';
import { AkumaPrimeSchema, AgtAkumaPrimeKwVM, AkumaPrimeType } from 'app/stores/ui/agt.akumaprime.ui.store';
import { useEffect, useState } from 'react';
import { AkumaPrimeListeAgt } from './AkumaPrimeListe';
import { AkumaPrimeSankeyChart } from './AkumaPrimeSankeyChart';
import { AkumaPrimeBnrOverview } from './AkumaPrimeBnrOverview';
import { AkumaPrimeOptions } from './AkumaPrimeOptions';

export const AkumaPrimeOverview = observer(() => {
	const { berichteUiiStore } = useStore();

	return (
		<>
			{!berichteUiiStore.selectedAgt && <AkumaPrimeBnrOverview />}
			{berichteUiiStore.selectedAgt && <AkumaPrimeAgtOverview />}
		</>
	);
});

export const AkumaPrimeAgtOverview = observer(() => {
	const { agtAkumaPrimeUiStore, berichteUiiStore } = useStore();

	const schemaEinordnung = AkumaPrimeSchema.filter((s) => s.type === AkumaPrimeType.einordnung);
	const schemaTerminierung = AkumaPrimeSchema.filter((s) => s.type === AkumaPrimeType.terminierung);

	const [agtItem, setAgtItem] = useState<AgtAkumaPrimeKwVM>();
	const [agtKwItems, setAgtKwItems] = useState<AgtAkumaPrimeKwVM[]>([]);

	useEffect(() => {
		agtAkumaPrimeUiStore.aggreagateAgtsByKw(agtAkumaPrimeUiStore.minKwCurrent, agtAkumaPrimeUiStore.maxKwCurrent).then((res) => {
			let items = res;
			if (berichteUiiStore.selectedAgt) {
				const agtId = berichteUiiStore.selectedAgt.agtId;
				agtAkumaPrimeUiStore.aggregateAgtByKw(agtId, agtAkumaPrimeUiStore.minKwCurrent, agtAkumaPrimeUiStore.maxKwCurrent).then((kwItems) => {
					setAgtItem(items.find((d) => d.agtId === agtId));
					setAgtKwItems(kwItems);
				});
			} else {
				setAgtItem(undefined);
			}
		});
	}, [agtAkumaPrimeUiStore, berichteUiiStore.selectedAgt, berichteUiiStore.menu, agtAkumaPrimeUiStore.minKwCurrent, agtAkumaPrimeUiStore.maxKwCurrent, agtItem, agtKwItems]);

	return (
		<>
			<AkumaPrimeOptions />
			<div className="table-container">
				{!agtItem && (
					<>
						<div className="pad-1rem content">
							<h3 className="title is-5">Keine Daten</h3>
							<p>Keine AKUMA Prime teilnahme.</p>
						</div>
					</>
				)}
				agtKwItems.length: {agtKwItems.length}
				{agtItem && agtKwItems.length > 0 && (
					<div className="pad-top-1rem pad-bottom-3rem">
						<>
							<div className="pad-1rem border-bottom">
								<h2 className="title is-3">Einordnung</h2>
								<AkumaPrimeSankeyChart type={AkumaPrimeType.einordnung} data={agtKwItems} />
							</div>
							<div className="pad-bottom-1rem">
								<AkumaPrimeListeAgt
									schema={schemaEinordnung}
									quoteProps={'einordnung.quote'}
									data={[agtItem]}
									primeType={AkumaPrimeType.einordnung}
									selectedAgt={berichteUiiStore.selectedAgt}
									showKw={false}
								/>
							</div>
						</>

						<>
							<div className="pad-1rem border-bottom">
								<h2 className="title is-3">Terminierung</h2>
								<AkumaPrimeSankeyChart type={AkumaPrimeType.terminierung} data={agtKwItems} />
							</div>
							<div className="pad-bottom-1rem">
								<AkumaPrimeListeAgt
									schema={schemaTerminierung}
									quoteProps={'einordnung.quote'}
									data={[agtItem]}
									primeType={AkumaPrimeType.terminierung}
									selectedAgt={berichteUiiStore.selectedAgt}
									showKw={false}
								/>
							</div>
						</>
					</div>
				)}
			</div>
		</>
	);
});

